// Pure voice-activity gate. Prevents whisper from ever seeing silence, which
// is the single most likely way this feature embarrasses us — tiny
// hallucinates ("Thank you.", "[BLANK_AUDIO]", ...) on empty audio.

export const MIN_SPEECH_DURATION_MS = 400;
export const MAX_CLIP_DURATION_MS = 15000;

// Below this RMS a frame is considered silence. Tuned for 16-bit-range
// float32 mic input after typical browser AGC/noise suppression.
const SILENCE_RMS_THRESHOLD = 0.01;
const FRAME_SIZE = 512;

function rms(frame: Float32Array): number {
  let sumSquares = 0;
  for (let i = 0; i < frame.length; i++) sumSquares += frame[i] * frame[i];
  return Math.sqrt(sumSquares / frame.length);
}

/** Total milliseconds of the clip that look like speech, at 16kHz. */
export function speechDurationMs(pcm16k: Float32Array): number {
  let speechFrames = 0;
  const totalFrames = Math.ceil(pcm16k.length / FRAME_SIZE);
  for (let i = 0; i < totalFrames; i++) {
    const frame = pcm16k.subarray(i * FRAME_SIZE, (i + 1) * FRAME_SIZE);
    if (rms(frame) >= SILENCE_RMS_THRESHOLD) speechFrames++;
  }
  return (speechFrames * FRAME_SIZE * 1000) / 16000;
}

/** Does this buffer contain enough speech to bother transcribing? */
export function containsSpeech(pcm16k: Float32Array): boolean {
  return speechDurationMs(pcm16k) >= MIN_SPEECH_DURATION_MS;
}
